export default "__VITE_ASSET__vuDW$2iA__"